import { createSelector } from 'reselect';
import moment from 'moment';

const getFate = ({ fate }) => fate;

const inputs = [getFate];

const output = (fate) => {
  const premiumSubExpiry = new Date(fate.premiumSubExpiryDateTime);
  const now = new Date();
  const diff = moment(premiumSubExpiry).diff(moment(now), 'days');
  return diff;
};

export default createSelector(inputs, output);